module.exports = __webpack_public_path__ + "img/detail-resi-notfound.5a12406e.png";